/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {callWSFunction} from "../APIClient.jsx";


const Nodes = function (nodeId) {

    /**
     * Create a new node
     * @param nodeName
     * @returns {Promise<void>}
     */
    async function create(nodeName) {

    }

    /**
     * Remove  a existing node
     * @returns {Promise<void>}
     */
    async function remove() {
        return callWSFunction("nodes.remove", {
            nodeId: nodeId
        })
    }

    /**
     * Returns information about the node
     * @returns {Promise<{nodeName, nodeDomain: string, indexKey, nodeIP: string, nodePointer: string, serverId: string, status: string}>}
     */
    async function getInfo() {
        return callWSFunction("nodes.getInfo", {
            nodeId: nodeId
        })
    }

    async function doesExist() {

    }

    async function getConfig() {
        return callWSFunction("nodes.getConfig", {
            nodeId: nodeId
        })
    }

    async function getPlannedConfig() {
        return callWSFunction("nodes.getPlannedConfig", {
            nodeId: nodeId
        })
    }

    async function getCurrentState() {
        return callWSFunction("nodes.getCurrentState", {
            nodeId: nodeId
        })
    }

    async function getInstallLog() {
        return callWSFunction("nodes.getInstallLog", {
            nodeId: nodeId
        })
    }

    async function updateClient() {
        return callWSFunction("nodes.updateClient", {
            nodeId: nodeId
        })
    }

    async function markBroken() {
        return callWSFunction("nodes.markBroken", {
            nodeId: nodeId
        })
    }

    async function setup() {
        return callWSFunction("nodes.setup", {
            nodeId: nodeId
        })

    }

    async function uploadFiles(con) {

    }

    async function restartClient(connection) {

    }

    async function addDomain(name) {


    }

    async function removeDomain(name) {

    }

    async function setStatus(newStatus) {

    }


    async function showLogs(connection, command) {


    }

    /**
     * Executes a shell command on the node
     * @param _connection  - The connection is optional, if it is not provided, it opens and closes automatically.
     * @param command {string}
     * @returns {Promise<*>}
     */
    async function runCommand(_connection, command) {

    }

    async function getSSHConnectionString() {

    }


    function addContainer() {

    }

    async function update(values) {
        return callWSFunction("nodes.update", {
            nodeId: nodeId,
            values: values
        })
    }

    async function getLogs() {


    }

    async function downloadLogs(_connection) {

    }


    async function getServerInfo() {

    }

    async function registerContainer(containerId) {

    }

    async function updateContainer(containerId) {

    }


    async function listAll() {
        return callWSFunction("nodes.listAll", {})
    }

    return {
        create,
        remove,
        getInfo,
        getLogs,
        setup,
        listAll,
        downloadLogs,
        update,
        getInstallLog,
        markBroken,
        addDomain,
        removeDomain,
        getServerInfo,
        getConfig,
        getPlannedConfig,
        getCurrentState,
        getSSHConnectionString,
        registerContainer,
        runCommand,
        uploadFiles,
        restartClient,
        doesExist,
        updateClient,
        updateContainer
    }
}

export {Nodes}